import { useState, useCallback } from "react";
import { profileService } from "../services/profileService";
import { handleApiError } from "@/lib/utils/errorHandler";
import type { ResetPasswordRequest } from "../types/profile.types";

export const useResetPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resetPassword = useCallback(
    async (payload: ResetPasswordRequest): Promise<boolean> => {
      setIsLoading(true);
      setError(null);
      setIsSuccess(false);

      try {
        await profileService.resetPassword(payload);
        setIsSuccess(true);
        return true;
      } catch (err) {
        const apiError = handleApiError(err);
        setError(apiError.message);
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    isLoading,
    isSuccess,
    error,
    resetPassword,
    clearError,
  };
};
